module.exports = __webpack_public_path__ + "static/media/alcohol-and-addictions@2x.d7a2ce02.png";